import '@lumiere/shared/services/sentry';
import '@/services/initLogger';
import '@/services/firebase/performance';
import start from './admin-app.start';
start();
